<template>
    <v-container class="grey lighten-5" fluid>
        <v-row align="center" justify="center">
            <v-col md="8" sm="8" xs="12">
                <v-card>
                   <v-card-title class="px-3">Add a new integration</v-card-title>
                    <v-divider></v-divider>

                        <v-row class="px-4 py-4 pb-2">
                            <v-col md="12" sm="12" xs="12" class="pb-0">
                                <v-select
                                    v-model="clearingInstitute"
                                    :items="clearingInstitutesList"
                                    label="Select a clearing institute"
                                    dense
                                ></v-select>
                            </v-col>
                        </v-row>

                        <secure-trading
                            v-if="clearingInstitute == 'Securetrading_Omnipay'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                            :divisions="divisions"
                            :partners="partners"
                            @refreshPartners="getPartners"
                        ></secure-trading>

                        <cashflows
                            v-if="clearingInstitute == 'Voice Commerce Group'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                            :divisions="divisions"
                            :partners="partners"
                            @refreshPartners="getPartners"
                        ></cashflows>

                        <bspayone
                            v-if="clearingInstitute == 'BSCardServices'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                            :divisions="divisions"
                            :partners="partners"
                            @refreshPartners="getPartners"
                        ></bspayone>

                        <paysafe
                            v-if="clearingInstitute == 'Optimalpayment'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                            :divisions="divisions"
                            :partners="partners"
                            @refreshPartners="getPartners"
                        ></paysafe>

                        <worldline
                            v-if="clearingInstitute == 'Worldline'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                            :divisions="divisions"
                            :partners="partners"
                            @refreshPartners="getPartners"
                        ></worldline>

                        <first-data
                            v-if="clearingInstitute == 'FDMS_UK'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                            :divisions="divisions"
                            :partners="partners"
                            @refreshPartners="getPartners"
                        ></first-data>

                        <elavon
                            v-if="clearingInstitute == 'Elavon'"
                            :state="state"
                            :clearingInstitute="clearingInstitute"
                            :divisions="divisions"
                            :partners="partners"
                            @refreshPartners="getPartners"
                        ></elavon>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import SecureTrading from '@/components/integrations/SecureTrading.vue';
import Cashflows from '@/components/integrations/Cashflows.vue';
import BSPayone from '@/components/integrations/BSPayone.vue';
import Paysafe from '@/components/integrations/Paysafe.vue';
import Worldline from '@/components/integrations/Worldline.vue';
import FirstData from '@/components/integrations/FirstData.vue';
import Elavon from '@/components/integrations/Elavon.vue';

export default {
    components: {
        'secure-trading': SecureTrading,
        'cashflows': Cashflows,
        'bspayone': BSPayone,
        'paysafe': Paysafe,
        'worldline': Worldline,
        'first-data': FirstData,
        'elavon': Elavon
    },
    beforeMount() {
        this.listDivisions();
        this.getPartners();
    },
    data() {
        return {
            divisions: [],
            clearingInstitute: null,
            partners: null,
            clearingInstitutesList: [{ value: 'Bambora (via Evry)', text: 'Bambora (via Evry)' },
                                     { value: 'BSCardServices', text: 'BS PAYONE' },
                                     { value: 'Voice Commerce Group', text: 'Cashflows' },
                                     { value: 'Concardis', text: 'Concardis' },
                                     { value: 'Elavon', text: 'Elavon' },
                                     { value: 'FDMS_UK', text: 'First Data' },
                                     { value: 'Optimalpayment', text: 'Paysafe' },
                                     { value: 'Securetrading_Omnipay', text: 'Secure Trading' },
                                     { value: 'Wirecard', text: 'Wirecard' },
                                     { value: 'Worldline', text: 'Worldline' }],
        }
    },
    methods: {
        listDivisions() {
            axios({
            method: 'post',
            url: 'list-divisions',
            data: { state: 'Live' },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.divisions = response.data.divisions.filter(division => division.state == 'LIVE')
                                                        .sort((a, b) => a.name.localeCompare(b.name));
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getPartners() {
            axios({
            method: 'get',
            url: 'get-partners',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.partners = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        }
    }
}
</script>

<style>

</style>